import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const sources = ["ERP", "WMS", "TMS", "MES", "Data Lake", "Business Intelligence", "Database", "Excel"];

export const IntegrationLayer = () => {
  const { t } = useLang();
  const localizedSources = [...sources, t.home.externalSources];
  return (
    <div data-testid="integration-diagram">
      {/* Dynamis orchestration layer */}
      <div className="border border-cyan bg-nb-light p-6 relative">
        <span className="eyebrow">Decision Intelligence Layer</span>
        <div className="mt-2 font-display text-lg text-white">Dynamis</div>
        <p className="text-sm text-cool-light mt-1 max-w-none">{t.home.integrationBody}</p>
      </div>

      {/* connectors */}
      <div className="flex justify-center">
        <svg width="100%" height="42" viewBox="0 0 900 42" preserveAspectRatio="none" aria-hidden="true">
          {localizedSources.map((_, i) => {
            const x = (900 / localizedSources.length) * i + 900 / localizedSources.length / 2;
            return <line key={i} x1="450" y1="0" x2={x} y2="42" stroke="#008B99" strokeWidth="1" className="dash-move" />;
          })}
        </svg>
      </div>

      {/* source systems */}
      <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-px bg-cool-dark border border-cool-dark">
        {localizedSources.map((s) => (
          <div key={s} className="bg-nb-base py-4 px-2 text-center" data-testid={`integration-source-${s.toLowerCase().replace(/\s/g, "-")}`}>
            <span className="text-xs font-mono text-cool-light">{s}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
